import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPaywall3CalendarCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g fill="currentColor">
      <path d="M6 2a.667.667 0 0 0-1.333 0v.667H4a2 2 0 0 0-2 2V12a2 2 0 0 0 2 2h3.333a.667.667 0 0 0 0-1.333H4A.667.667 0 0 1 3.333 12V6.667h9.334V8A.667.667 0 1 0 14 8V4.667a2 2 0 0 0-2-2h-.667V2A.667.667 0 1 0 10 2v.667H6z" />
      <path d="M14.52 11.083a.667.667 0 1 0-1.04-.833l-2.202 2.752-.807-.807a.667.667 0 0 0-.942.943l1.333 1.333a.667.667 0 0 0 .992-.055z" />
    </g>
  </svg>
);
export default SvgPaywall3CalendarCheck;
